import { render, staticRenderFns } from "./PrivilegeCategoryInfo.vue?vue&type=template&id=55ddcfce&"
import script from "./PrivilegeCategoryInfo.vue?vue&type=script&lang=js&"
export * from "./PrivilegeCategoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./PrivilegeCategoryInfo.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports